var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center contenido"},[_c('div',{staticClass:"col-12 col-md-12 col-lg-12 col-xl-12"},[_c('div',{staticClass:"foco-intro"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.$t('cover.text_intro'))}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }